import iosBridge from './ios_bridge'
import logout from './logout';
import media_utility from './media_utility';
import request from './curl';
import utility from './utility';

export default {
  data: () => ({
    value: false,
    currentItem: null,
    drawer:null,
    v_navigation_drawer:{},
    overlay_opacity: 0.2,
    overlay:false,
    overlay_zIndex:99,
    user_contact_list_lf:{},
    isMobileDevice: window.__IS__MOBILE_DEVICE__,
    inviteCount: [],
    show_gide_logo: true,
    VUE_APP_ENV: process.env.VUE_APP_ENV
  }),
  computed: {
    isOnGide() {
      return this.$store.getters.getIsOnGide
    },
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    userData() {
      return this.$store.getters.userData;
    },
    async getChatgrpList(){
      return await this.$store.getters.getChatgrpList;
    },
    getSearchBar() {
      return this.$store.getters.getSearchBar;
    },
    getClientDeviceHeight(){
      return this.$store.getters.getClientDeviceHeight;
    },
    async getUserContactList(){
      return await this.$store.getters.getUserContactList;
    },
    async geto2oInvite(){
      return await this.$store.getters.geto2oInvite;
    }
  },
  async mounted() {
    this.v_navigation_drawer = {
      'background-color': this.$theme.primary_bg_color,
      'min-height':this.getClientDeviceHeight+'px'
    }
    this.user_contact_list_lf = await this.getUserContactList;
    this.inviteCount = await this.geto2oInvite
  },
  methods: {
    gotoHome() {
      if(this.isMobileDevice) {
        window.open(process.env.VUE_APP_GIDE_DOMAIN)
      }
      else if(this.$route.path != '/chat') {
        this.$router.push('/chat');
      }      
    },
    goToInvite() {
      this.$router.push("/invite")
    },  
    logout() {
      this.overlay = true;
      logout.logout("navbar");
    },
    user_profile(){
      this.$store.commit('setParticipantId', this.userData.user_id);
      this.$router.push({name:"participant_profile"});
    },
    async showSearchBar(){
      if(await this.getChatgrpList){
        this.$store.commit('setSearchBar', true);
      }
    },
    /*
     * term_of_use
     *
     */
    term_of_use(){
      if(window.webkit){
        iosBridge.sendMessage({"module":"launchInBrowser", "data":{"url":process.env.VUE_APP_TNC_LINK}});
      }
      else{
        window.open(process.env.VUE_APP_TNC_LINK, '_blank');
      }
    },
    /*
    * get_user_icon
    * */
    get_user_icon(user){
      var user_icon = media_utility.get_user_icon(user, this.user_contact_list_lf);
      return user_icon;
    },
    /*
    * checkStrFirstCharHasAlphabet
    * */
    checkStrFirstCharHasAlphabet(str){
      if(/^[A-Za-z]/.test(str)) {
        return true;
      }
      return false;
    },
    /**
     * initiateChatBot
    */
   async initiateChatBot () {
     try {
        // check if a group with GideBot exists or not, if yes take the user to 'chat_message'
        let chatgrp_list = await this.getChatgrpList;
        chatgrp_list = chatgrp_list ? chatgrp_list : [];

        let gideBotGrpExists = chatgrp_list.find(e => e.created_By == process.env.VUE_APP_GIDE_GPT_USER_ID)
        if (gideBotGrpExists) {
          await this.$store.commit('setSelectedGroup', gideBotGrpExists.group_id);
          this.$router.push("chat_message")
          return
        }

        let groupId = utility.getUniqueId(this.userData.user_id, process.env.VUE_APP_GIDE_GPT_USER_ID);
        const payload = {
          chat_user_id: process.env.VUE_APP_GIDE_GPT_USER_ID,
          type: "0",
          group_id: groupId,
          group_name: "gideX",
          group_description: `Hello Feel free to ask me anything about universities, application processes, scholarships, or any concerns you may have. Let's work together to make your study abroad dreams a reality!`,
          participants: JSON.stringify(
            [
              {"is_Admin":1,"participant_id":process.env.VUE_APP_GIDE_GPT_USER_ID,"short_bio":""}, // GIDE BOT
              {"is_Admin":0,"participant_id":this.userData.user_id,"short_bio":""} // GIDE USER
            ]
          ),
          acc_id: null
        }

        let post_data = new FormData()
        for (let key in payload) {
          post_data.append(key, payload[key])
        }

        request.curl(this, "group_add", post_data)
        .then(async response => {
          if(response.resp_status) {
            this.data = response.resp_data;
            await this.$store.commit('setSelectedGroup', response.resp_data.group_id);

            this.data['last_msg'] = response.resp_data_1.text_msg;
            this.data['last_msg_sender'] = this.userData.user_name;
            this.data['last_msg_time'] = utility.get_message_datetime(this.data.created_on, 'DD/MM/YYYY');

            if(chatgrp_list && chatgrp_list.length > 0) {
              chatgrp_list.unshift(this.data);
            }
            else{
              chatgrp_list = [];
              chatgrp_list.push(this.data)
            }

            await this.$store.commit('setChatgrpList', chatgrp_list);
            setTimeout(() => {
              this.$router.push('/chat_message');
            }, 250);
          }
        });
     }
     catch (err) {
       console.error("Exception in initiateChatBot and err: ", err)
     } 
   }
  },
  watch: {
    getUserContactList: async function (user_data) { 
      this.user_contact_list_lf = await user_data;
    },
    geto2oInvite : async function (o2oInvite) {
      this.inviteCount = await o2oInvite
    },
    "$route.path": function (newPath) {
      if (newPath == "/invite") {
        this.show_gide_logo = false
      }
      else {
        this.show_gide_logo = true
      }
    }
  }
}
